import { render, staticRenderFns } from "./ModalGallery.vue?vue&type=template&id=2bd8ba7a&lang=pug&"
import script from "./ModalGallery.vue?vue&type=script&lang=js&"
export * from "./ModalGallery.vue?vue&type=script&lang=js&"
import style0 from "./ModalGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports